<canvas
  baseChart
  class="chart"
  [data]="radarChartData"
  [options]="radarChartOptions"
  [type]="radarChartType"
>
</canvas>